export * from './component/documentdetails/document-index/document-index.component';
export * from './component/documentdetails/document-list/document-list.component';
export * from './component/documentdetails/document-filter/document-filter.component';
export * from './component/documentdetails/document-history/document-history.component';

export * from './component/master/master-index/master-index.component';

export * from './component/master/company-list/company-list.component';
export * from './component/master/company-entity/company-entity.component';
export * from './component/master/minesite-list/minesite-list.component';
export * from './component/master/minesite-entity/minesite-entity.component';
export * from './component/master/model-list/model-list.component';
export * from './component/master/model-entity/model-entity.component';
export * from './component/master/poweredby-entity/poweredby-entity.component';
export * from './component/master/equipment-entity/equipment-entity.component';
export * from './component/master/preset-list/preset-list.component';
export * from './component/master/preset-entity/preset-entity.component';
export * from './component/master/preset-filter/preset-filter.component';
export * from './component/master/company-filter/company-filter.component';
export * from './component/master/minesite-filter/minesite-filter.component';
export * from './component/master/equipment-filter/equipment-filter.component';

export * from './component/master/model-manipulate/model-manipulate.component';
export * from './component/master/model-details/model-details.component';
export * from './component/master/equipment-manipulate/equipment-manipulate.component';
export * from './component/master/equipment-details/equipment-details.component';

export * from './component/master/attribute-edit/attribute-edit.component';

export * from './component/documentassociation/presetassociation-index/presetassociation-index.component';

export * from './component/documentassociation/documentassociation-index/documentassociation-index.component';
export * from './component/documentassociation/recommended/recommended.component';
export * from './component/documentassociation/documentselection/documentselection.component';
export * from './component/documentassociation/advanced-document-filter/advanced-document-filter.component';

export * from './component/master/staged-tab/staged-tab.component';
export * from './component/master/live-tab/live-tab.component';
export * from './component/master/staging-tabs/staging-tabs.component';
export * from './component/master/project-list/project-list.component';
export * from './component/master/Snapshot-list/Snapshot-list.component';

export * from './association.routing';
